import { writable } from 'svelte/store'
import * as ls from 'local-storage';

const theme = writable({ mode: ls.get("mode") || "dark" });

export default theme;